module.exports = __webpack_public_path__ + "static/media/How to Guide For Grad Goggles.c8f58e37.pdf";